import React, { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import Spinner from "elements/Spinner";
import FullLayout from "layouts/FullLayout";

const OpenRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest}>
      <Suspense fallback={<Spinner />}>
        <FullLayout>{React.createElement(component, rest)}</FullLayout>
      </Suspense>
    </Route>
  );
};

export default OpenRoute;
